import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import { CompareArrows } from "@material-ui/icons";

import { connect, useDispatch } from "react-redux";
import axios from "axios";
import Loader from "../../Loader/Loader";
import DataTable from "../components/DataTable";
import { Typography, Drawer } from "@material-ui/core";
import flightBanner from "../../../assets/img/flight-banner.png";
import IconBack from "@material-ui/icons/ArrowBack";
import PopularDestinations from "../components/PopularDestinations/PopularDestinations";
import "../index.css";
import { momentToHrs } from "../../../helpers/date.helper";
import { addToHistory } from "../utils/SearchHistory";
import RecentSearches from "../components/RecentSearches";
import moment from "moment";
import PriceGraph from "../components/PriceGraph";
import FlightProviders from "../utils/FlightProviders";
import classes from "./FlightResults.module.css";
import Footer from "../../../components/Flight/components/Home Footer/Footer";
/////////////////////////////////////////////////////////

import FlightDetails from "../components/Flight Details/FlightDetails";
import FlightSearch from "../FlightSearch/FlightSearchV2";

//////////////////////////////////////////////////

import { getVendorDetails } from "../../../store/actions/vendor/Vendor";
import { getCommission } from "../../../store/actions/admin/Admin";
import FlightList from "./FlightList/FlightList";
import FlightFilter from "../components/Flight Filters/FlightFilters";
const CancelToken = axios.CancelToken;
let source = CancelToken.source();

const SESSION_KEY = "SESSION_KEY";

const DateStringToDate = (d) => {
  let date = new Date(d);
  return date;
};

function createUTCdateForISO(dateString) {
  const offset = new Date().getTimezoneOffset();
  const myDate = Date.parse(dateString) + offset * 60 * 1000;
  const dateAsISO = new Date(myDate).toISOString();

  return dateAsISO;
}

function FlightResults(props) {
  const search = useLocation().search;
  const searchParam = new URLSearchParams(search);
  const [selectedDepartureDate, setSelectedDepartureDate] = React.useState(
    searchParam.get("selectedDepartureDate")
  );
  const [journeyType, setJourneyType] = React.useState(
    searchParam.get("journeyType") ? searchParam.get("journeyType") : "One Way"
  );
  const [selectedArrivalDate, setSelectedArrivalDate] = React.useState(
    searchParam.get("selectedArrivalDate")
  );
  const [departureAirport, setDepartureAirport] = React.useState(
    searchParam.get("departureAirport")
  );
  const [departureAirportName, setDepartureAirportName] = React.useState(
    searchParam.get("departureAirportName")
  );
  const [arrivalAirport, setArrivalAirport] = React.useState(
    searchParam.get("arrivalAirport")
  );
  const [arrivalAirportName, setArrivalAirportName] = React.useState(
    searchParam.get("arrivalAirportName")
  );
  const [adults, setAdults] = React.useState(
    searchParam.get("adults") ? Number(searchParam.get("adults")) : 1
  );
  const [kids, setKids] = React.useState(
    searchParam.get("kids") ? Number(searchParam.get("kids")) : 0
  );
  const [infants, setInfants] = React.useState(
    searchParam.get("infants") ? Number(searchParam.get("infants")) : 0
  );
  const [flightClass, setFlightClass] = React.useState(
    searchParam.get("flightClass") ? searchParam.get("flightClass") : "Any"
  );
  const [flights, setFlights] = useState([]);
  const [minMaxPrice, setMinMaxPrice] = useState({ min: 0, max: 0 });
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("price");

  /////////////////////////FILTERS////////////////////////////////

  const [flyDuration, setFlyDuration] = useState(1);
  const [showFilters, setShowFilters] = useState(false);
  const [useflyDuration, setUseFlyDuration] = useState(false);
  const [useSortBy, setUseSortBy] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 1000]);
  const [usePriceRange, setUsePriceRange] = useState(false);
  const [arrivalTimeRange, setArrivalTimeRange] = useState({
    min: new Date(),
    max: new Date(),
  });
  const [useArrivalTimeRange, setUseArrivalTimeRange] = useState(false);
  const [baggage, setBaggage] = useState({
    hand_bag: 0,
    hold_bag: 0,
  });
  const [useBaggage, setUseBaggage] = useState(false);
  const [departureTimeRange, setDepartureTimeRange] = useState({
    min: new Date(),
    max: new Date(),
  });
  const [useDepartureTimeRange, setUseDepartureTimeRange] = useState(false);
  const [stops, setStops] = useState(0);
  const [useStops, setUseStops] = useState(false);
  const [sessionLoaded, setSessionLoaded] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [page, setPage] = useState(props.page || 2);
  const [searchQuery, setSearchQuery] = useState("");

  //////////////////////FILTERS END///////////////////////////////

  const [flightDetail, setFlightDetail] = useState();
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      let sessionData = sessionStorage.getItem(SESSION_KEY);
      if (sessionData) {
        sessionData = JSON.parse(sessionData);
        setDepartureAirport(sessionData["departureAirport"]);
        setDepartureAirportName(sessionData["departureAirportName"]);
        setSelectedDepartureDate(moment(sessionData["selectedDepartureDate"]));
        setArrivalAirport(sessionData["arrivalAirport"]);
        setArrivalAirportName(sessionData["arrivalAirportName"]);
        setAdults(sessionData["adults"]);
        setKids(sessionData["kids"]);
        setInfants(sessionData["infants"]);
        setSortBy(sessionData["sortBy"]);
        setStops(sessionData["stops"]);
        setFlightClass(sessionData["flightClass"]);
        setSelectedArrivalDate(moment(sessionData["selectedArrivalDate"]));
        setFlyDuration(sessionData["flyDuration"]);
        setPriceRange(sessionData["priceRange"]);
        setBaggage(
          sessionData["baggage"] || {
            hand_bag: "0",
            hold_bag: "0",
          }
        );
        setDepartureTimeRange(sessionData["departureTimeRange"]);
        setArrivalTimeRange(sessionData["arrivalTimeRange"]);
        setSessionLoaded(true);
      }
    } catch (err) {
      console.log(err);
    }

    props.dispatch(getCommission());

    let loginType = localStorage.getItem("userLoginType");
    if (loginType == "vendor" && props.commissionType == "") {
      props.dispatch(getVendorDetails());
    }
  }, []);

  useEffect(() => {
    if (sessionLoaded) {
      // searchFlights();
      setSessionLoaded(false);
    }
  }, [sessionLoaded]);

  useEffect(() => {
    fetchData();
  }, [
    flyDuration,
    sortBy,
    priceRange,
    arrivalTimeRange,
    baggage,
    departureTimeRange,
    stops,
  ]);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setDrawerOpen(open);
  };

  const fetchData = async function () {
    if (props.onFlightSearch) {
      return props.onFlightSearch.call({
        departureAirport,
        arrivalAirport,
        selectedDepartureDate,
        journeyType,
        selectedArrivalDate,
        setDrawerOpen,
        departureAirportName,
        arrivalAirportName,
        adults,
        kids,
        infants,
        flightClass,
        setLoading,
        sortBy,
        useStops,
        stops,
        useflyDuration,
        flyDuration,
        usePriceRange,
        priceRange,
        useDepartureTimeRange,
        departureTimeRange,
        useArrivalTimeRange,
        arrivalTimeRange,
        useBaggage,
        baggage,
      });
    }
    setFlights([]);
    let flightsArray = [];

    const sessionData = {};
    if (!departureAirport || !arrivalAirport || !selectedDepartureDate) {
      return;
    }
    if (journeyType === "Return" && !selectedArrivalDate) {
      return;
    }

    setDrawerOpen(false);
    let RecentSearches = addToHistory({
      start: { code: departureAirport, name: departureAirportName },
      end: { code: arrivalAirport, name: arrivalAirportName },
      journey_type: journeyType,
      arrivalDate: selectedArrivalDate,
      departureDate: selectedDepartureDate,
      adults: adults,
      kids: kids,
      infants: infants,
      flightClass: flightClass,
    });

    const { dispatch } = props;
    dispatch({ type: "SET_SEARCH_HISTORY", data: RecentSearches });

    setLoading(true);
    let normalQueryParam = `flights/airlines-offer?fly_from=${departureAirport}&date_from=${moment(
      selectedDepartureDate
    ).format(
      "DD/MM/yyyy"
    )}&fly_to=${arrivalAirport}&limit=250&adults=${adults}&children=${kids}&infants=${infants}`;
    let flySmartQueryParam = `flights/offers-b2b?date_from=${moment(
      selectedDepartureDate
    ).format(
      "DD-MM-yyyy"
    )}&fly_from=${departureAirport}&fly_to=${arrivalAirport}&adults=${adults}&children=${kids}&infants=${infants}`;
    let airiqQueryParam = `flights/offers-airiq?date_from=${moment(
      selectedDepartureDate
    ).format(
      "yyyy/MM/DD"
    )}&fly_from=${departureAirport}&fly_to=${arrivalAirport}&adults=${adults}&children=${kids}&infants=${infants}`;
    const tboQueryParam = `flights/offers-tbo?date_from=${moment(
      selectedDepartureDate
    ).format(
      "yyyy-MM-DD"
    )}&fly_from=${departureAirport}&fly_to=${arrivalAirport}&adults=${adults}&children=${kids}&infants=${infants}`;

    sessionData["departureAirport"] = departureAirport;
    sessionData["departureAirportName"] = departureAirportName;
    sessionData["selectedDepartureDate"] = selectedDepartureDate;
    sessionData["arrivalAirport"] = arrivalAirport;
    sessionData["arrivalAirportName"] = arrivalAirportName;
    sessionData["adults"] = adults;
    sessionData["kids"] = kids;
    sessionData["infants"] = infants;

    dispatch({
      type: "SET_JOURNEY_DETAILS",
      data: {
        departureAirport,
        departureAirportName,
        selectedDepartureDate,
        arrivalAirport,
        arrivalAirportName,
        adults,
        kids,
        infants,
        baggage,
      },
    });

    if (sortBy) {
      normalQueryParam += `&sort=${sortBy}`;
      sessionData["sortBy"] = sortBy;
    }
    // if (selectedCurrency) {
    //   queryParam += `&currency=${selectedCurrency}`
    //   priceSearchQuery+= `&currency=${selectedCurrency}`
    // }
    let currency = props.currency;
    if (!currency) {
      currency = localStorage.getItem("selectedCurrency");
    }
    if (currency) normalQueryParam += `&currency=${currency}`;

    if (useStops && stops != -1 && stops != 2) {
      normalQueryParam += `&max_stopovers=${stops}`;
      sessionData["stops"] = stops;
    }
    if (flightClass && flightClass !== "Any") {
      normalQueryParam += `&selected_cabins=${flightClass}`;
      sessionData["flightClass"] = flightClass;
    }

    if (journeyType === "Return" && selectedArrivalDate) {
      normalQueryParam += `&return_from=${moment(selectedArrivalDate).format(
        "DD/MM/yyyy"
      )}`;
      sessionData["selectedArrivalDate"] = selectedArrivalDate;
    }

    if (useflyDuration && flyDuration != 0) {
      normalQueryParam += `&max_fly_duration=${flyDuration}`;
      sessionData["flyDuration"] = flyDuration;
    }

    if (
      usePriceRange &&
      priceRange &&
      priceRange[0] >= 0 &&
      priceRange[1] != 0
    ) {
      normalQueryParam += `&price_from=${priceRange[0]}&price_to=${priceRange[1]}`;
      // sessionData["priceRange"] = priceRange;
    }
    if (
      useDepartureTimeRange &&
      departureTimeRange &&
      departureTimeRange.min != "" &&
      departureTimeRange.max != ""
    ) {
      normalQueryParam += `&dtime_from=${momentToHrs(
        departureTimeRange.min
      )}&dtime_to=${momentToHrs(departureTimeRange.max)}`;
      sessionData["departureTimeRange"] = departureTimeRange;
    }

    if (
      useArrivalTimeRange &&
      arrivalTimeRange &&
      arrivalTimeRange.min != "" &&
      arrivalTimeRange.max != ""
    ) {
      normalQueryParam += `&atime_from=${momentToHrs(
        arrivalTimeRange.min
      )}&atime_to=${momentToHrs(arrivalTimeRange.max)}`;
      sessionData["arrivalTimeRange"] = arrivalTimeRange;
    }
    if (useBaggage && baggage) {
      if (baggage.hand_bag != "0") {
        normalQueryParam += `&adult_hand_bag=${parseInt(baggage.hand_bag)}`;
      }

      if (baggage.hold_bag != "0") {
        normalQueryParam += `&adult_hold_bag=${parseInt(baggage.hold_bag)}`;
      }
      sessionData["baggage"] = baggage;
    }
    source && source.cancel();
    source = axios.CancelToken.source();
    const [
      normalFlightResponse,
      flySmartFlightResponse,
      airiqFlightResponse,
      tboFlightResponse,
    ] = await Promise.allSettled([
      axios.get(normalQueryParam, { cancelToken: source.token }),
      axios.get(flySmartQueryParam, { cancelToken: source.token }),
      axios.get(airiqQueryParam, { cancelToken: source.token }),
      axios.get(tboQueryParam, { cancelToken: source.token }),
    ]);

    if (
      normalFlightResponse.status === "fulfilled" &&
      normalFlightResponse.value.data &&
      normalFlightResponse.value.data.data
    ) {
      let data = normalFlightResponse.value.data.data.data || [];
      data &&
        data.map((d) => {
          let slices = [];
          if (journeyType !== "Return") {
            let slice = {
              origin: departureAirport,
              destination: arrivalAirport,
              duration: d.duration.departure,
              airline: {},
            };
            let segments = [];
            d.route.map((route) => {
              segments.push(route);
              slice.airline[route.airline] = 1;
            });
            slice.segments = segments;
            slices.push(slice);
          } else {
            let segments = [];
            let slice = {
              origin: departureAirport,
              destination: arrivalAirport,
              duration: d.duration.departure,
              airline: {},
            };
            d.route.map((route) => {
              segments.push(route);
              slice.airline[route.airline] = 1;
              if (route.cityTo === arrivalAirportName) {
                slice.segments = [...segments];
                slices.push({ ...slice });
                segments = [];
                slice = {
                  destination: departureAirport,
                  origin: arrivalAirport,
                  duration: d.duration.return,
                  airline: {},
                };
              }
            });
            slice.segments = [...segments];
            slices.push({ ...slice });
          }
          d.slices = slices;
          d.provider = FlightProviders.KIWI;

          return d;
        });

      flightsArray = [...flightsArray, ...data].sort(
        (a, b) => a.price - b.price
      );
    }

    if (
      !(journeyType === "Return" && selectedArrivalDate) &&
      flySmartFlightResponse.status === "fulfilled" &&
      flySmartFlightResponse.value.data
    ) {
      const { data = [] } = flySmartFlightResponse.value.data;
      const flightsData = data.map((d) => {
        const slices = [
          {
            duration:
              (new Date(`${d.arrival_date} ${d.arrival_time}`) -
                new Date(`${d.travel_date} ${d.departure_time}`)) /
              1000,
            airline: { [d.airline.code]: 1 },
            segments: [
              {
                flyFrom: d.destination.destination.code,
                flyTo: d.destination.origin.code,
                flight_no: d.flight_no.split(" ")[1],
                fare_category: "M",
                operating_carrier: d.airline.code,
                airline: d.airline.code,
                local_departure: new Date(
                  `${d.travel_date} ${d.departure_time}`
                ).toISOString(),
                utc_departure: new Date(
                  `${d.travel_date} ${d.departure_time}`
                ).toISOString(),
                local_arrival: new Date(
                  `${d.arrival_date} ${d.arrival_time}`
                ).toISOString(),
                utc_arrival: new Date(
                  `${d.arrival_date} ${d.arrival_time}`
                ).toISOString(),
              },
            ],
          },
        ];
        return {
          ticked_id: d.id,
          flight_id: d.flight_no.replace(" ", "-"),
          cityCodeFrom: d.destination.destination.code,
          cityCodeTo: d.destination.origin.code,
          cityFrom: sessionData["departureAirportName"],
          cityTo: sessionData["arrivalAirportName"],
          slices,
          price: d.total_price,
          baglimit: {
            hand_weight:
              d.baggage_info
                .find((info) => info.name === "Cabin  Baggage")
                ?.adult?.split(" ")[0] || "0",
            hold_weight:
              d.baggage_info
                .find((info) => info.name === "Check-in Baggage")
                ?.adult?.split(" ")[0] || "0",
          },
          provider: FlightProviders.GOFLYSMART,
        };
      });
      flightsArray = [...flightsArray, ...flightsData].sort(
        (a, b) => a.price - b.price
      );
      // setFlights(prev => [...prev, ...flightsData].sort((a, b) => a.price - b.price));
    }

    if (
      !(journeyType === "Return" && selectedArrivalDate) &&
      airiqFlightResponse.status === "fulfilled" &&
      airiqFlightResponse.value.data
    ) {
      const { data = [] } = airiqFlightResponse.value.data;
      const flightsData = data.map((d) => {
        const slices = [
          {
            duration:
              (new Date(`${d.arival_date} ${d.arival_time}`) -
                new Date(`${d.departure_date} ${d.departure_time}`)) /
              1000,
            airline: { [d.flight_number.split(" ")[0]]: 1 },
            segments: [
              {
                flyFrom: d.origin,
                flyTo: d.destination,
                fare_category: "M",
                flight_no: d.flight_number.split(" ")[1],
                operating_carrier: d.flight_number.split(" ")[0],
                airline: d.flight_number.split(" ")[0],
                utc_departure: new Date(
                  `${d.departure_date} ${d.departure_time}`
                ),
                local_departure: new Date(
                  `${d.departure_date} ${d.departure_time}`
                ),
                utc_arrival: new Date(`${d.arival_date} ${d.arival_time}`),
                local_arrival: new Date(`${d.arival_date} ${d.arival_time}`),
              },
            ],
          },
        ];
        return {
          ticket_id: d.ticket_id,
          flight_id: d.ticket_id,
          flight_number: d.flight_number.replace(" ", "-"),
          cityCodeFrom: d.origin,
          cityCodeTo: d.destination,
          cityFrom: sessionData["departureAirportName"],
          cityTo: sessionData["arrivalAirportName"],
          slices,
          price: d.price,
          provider: FlightProviders.AIRIQ,
        };
      });

      // setFlights((prev) =>
      //   [...prev, ...flightsData].sort((a, b) => a.price - b.price)
      // );
      flightsArray = [...flightsArray, ...flightsData].sort(
        (a, b) => a.price - b.price
      );
    }

    // Add TBO flights handling
    if (
      !(journeyType === "Return" && selectedArrivalDate) &&
      tboFlightResponse.status === "fulfilled" &&
      tboFlightResponse.value.data
    ) {
      const { data = [] } = tboFlightResponse.value.data;
      const flightsData = data.map((d) => {
        const slices = [
          {
            duration:
              (new Date(`${d.arrival_date} ${d.arrival_time}`) -
                new Date(`${d.departure_date} ${d.departure_time}`)) /
              1000,
            airline: { [d.airline_code]: 1 },
            segments: [
              {
                flyFrom: d.origin_airport,
                flyTo: d.destination_airport,
                fare_category: "M",
                flight_no: d.flight_number,
                operating_carrier: d.airline_code,
                airline: d.airline_code,
                utc_departure: new Date(
                  `${d.departure_date} ${d.departure_time}`
                ),
                local_departure: new Date(
                  `${d.departure_date} ${d.departure_time}`
                ),
                utc_arrival: new Date(`${d.arrival_date} ${d.arrival_time}`),
                local_arrival: new Date(`${d.arrival_date} ${d.arrival_time}`),
              },
            ],
          },
        ];
        return {
          ticket_id: d.ticket_id,
          flight_id: d.ticket_id,
          flight_number: d.flight_number,
          cityCodeFrom: d.origin_airport,
          cityCodeTo: d.destination_airport,
          cityFrom: sessionData["departureAirportName"],
          cityTo: sessionData["arrivalAirportName"],
          slices,
          price: d.total_fare,
          baglimit: {
            hand_weight: d.cabin_baggage || "0",
            hold_weight: d.checkin_baggage || "0",
          },
          provider: FlightProviders.TBO,
        };
      });

      flightsArray = [...flightsArray, ...flightsData].sort(
        (a, b) => a.price - b.price
      );
    }

    let flightNoMap = {};
    // console.log("flightArray=====1", flightsArray);
    // flightsArray = flightsArray.filter((airport) => {
    //   let flightNo = airport.slices[0].segments[0].flight_no;
    //   if (flightNoMap[flightNo]) {
    //     return false;
    //   }
    //   flightNoMap[flightNo] = true;
    //   return true;
    // });
    // console.log("flightArray=====2", flightsArray);

    if (sortBy && sortBy === "duration") {
      flightsArray.sort((a, b) => a.duration.departure - b.duration.departure);
    }

    if (flightsArray && flightsArray.length > 0) {
      let min = flightsArray[0]?.conversion?.INR
        ? flightsArray[0]?.conversion?.INR
        : 0;
      let max = flightsArray[flightsArray.length - 1]?.conversion?.INR
        ? flightsArray[flightsArray.length - 1]?.conversion?.INR
        : 0;
      setMinMaxPrice({ min, max });
    }
    setFlights(flightsArray);
    setPage(2);

    sessionStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));

    setLoading(false);
  };

  const searchFlights = function (e) {
    e.preventDefault();
    const sessionData = {};
    if (!departureAirport || !arrivalAirport || !selectedDepartureDate) {
      return;
    }
    if (journeyType === "Return" && !selectedArrivalDate) {
      return;
    }

    // setDrawerOpen(false);
    let RecentSearches = addToHistory({
      start: {
        code: departureAirport,
        name: departureAirportName,
      },
      end: {
        code: arrivalAirport,
        name: arrivalAirportName,
      },
      journey_type: journeyType,
      arrivalDate: selectedArrivalDate,
      departureDate: selectedDepartureDate,
      adults: adults,
      kids: kids,
      infants: infants,
      flightClass: flightClass,
    });

    dispatch({
      type: "SET_SEARCH_HISTORY",
      data: RecentSearches,
    });

    // setLoading(true);

    let queryParam = `/flights/airlines-offer?departureAirport=${departureAirport}&departureAirportName=${departureAirportName}&selectedDepartureDate=${selectedDepartureDate}&arrivalAirport=${arrivalAirport}&arrivalAirportName=${arrivalAirportName}&adults=${adults}&kids=${kids}&infants=${infants}&journeyType=${journeyType}`;

    sessionData["departureAirport"] = departureAirport;
    sessionData["departureAirportName"] = departureAirportName;
    sessionData["selectedDepartureDate"] = selectedDepartureDate;
    sessionData["arrivalAirport"] = arrivalAirport;
    sessionData["arrivalAirportName"] = arrivalAirportName;
    sessionData["adults"] = adults;
    sessionData["kids"] = kids;
    sessionData["infants"] = infants;

    if (sortBy) {
      queryParam += `&sortBy=${sortBy}`;
      sessionData["sortBy"] = sortBy;
    }
    let currency = props.currency;
    if (currency) queryParam += `&currency=${currency}`;

    if (useStops && stops != -1 && stops != 2) {
      queryParam += `&stops=${stops}`;
      sessionData["stops"] = stops;
    }
    if (flightClass && flightClass !== "Any") {
      queryParam += `&flightClass=${flightClass}`;
      sessionData["flightClass"] = flightClass;
    }

    if (journeyType === "Return" && selectedArrivalDate) {
      queryParam += `&selectedArrivalDate=${selectedArrivalDate}`;
      sessionData["selectedArrivalDate"] = selectedArrivalDate;
    }

    if (useflyDuration && flyDuration != 0) {
      queryParam += `&flyDuration=${flyDuration}`;
      sessionData["flyDuration"] = flyDuration;
    }
    if (
      usePriceRange &&
      priceRange &&
      priceRange[0] >= 0 &&
      priceRange[1] != 0
    ) {
      queryParam += `&price_from=${priceRange[0]}&price_to=${priceRange[1]}`;
    }
    if (
      useDepartureTimeRange &&
      departureTimeRange &&
      departureTimeRange.min != "" &&
      departureTimeRange.max != ""
    ) {
      queryParam += `&dtime_from=${momentToHrs(
        departureTimeRange.min
      )}&dtime_from=${momentToHrs(departureTimeRange.max)}`;
      sessionData["departureTimeRange"] = departureTimeRange;
    }

    if (
      useArrivalTimeRange &&
      arrivalTimeRange &&
      arrivalTimeRange.min != "" &&
      arrivalTimeRange.max != ""
    ) {
      queryParam += `&atime_from=${momentToHrs(
        arrivalTimeRange.min
      )}&atime_from=${momentToHrs(arrivalTimeRange.max)}`;
      sessionData["arrivalTimeRange"] = arrivalTimeRange;
    }
    if (useBaggage && baggage) {
      if (baggage.hand_bag != "0") {
        queryParam += `&adult_hand_bag=${baggage.hand_bag}`;
      }

      if (baggage.hold_bag != "0") {
        queryParam += `&adult_hold_bag=${baggage.hold_bag}`;
      }
      sessionData["baggage"] = baggage;
    }
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
    props.history.push(queryParam);
    props.history.go(0);

    // setLoading(false);
  };

  useEffect(() => {
    if (!loading) {
      if (page == 1)
        setTimeout(() => {
          window.scrollTo({ top: 250, behavior: "smooth" });
        }, 0);
    }
  }, [loading]);

  const handleFlightSelect = (flight) => {
    const { dispatch } = props;
    dispatch({ type: "SELECTED_FLIGHT", flight });
    console.log("selected flight|inside flightresults||", flight);
    props.history.push(
      `/flights-book/v${flight.provider}/${
        flight.provider === FlightProviders.KIWI
          ? flight.booking_token
          : flight.flight_id
      }?journeyType=${journeyType}&departureAirport=${departureAirport}&arrivalAirport=${arrivalAirport}&departureDate=${selectedDepartureDate}&arrivalDate=${selectedArrivalDate}&adults=${adults}&kids=${kids}&infants=${infants}&flightClass=${flightClass}`
    );
  };

  const handleSortByChange = (val) => {
    setUseSortBy(true);
    setSortBy(val);
  };

  const handleFlyDurationChange = (val) => {
    setUseFlyDuration(true);
    setFlyDuration(val);
  };

  const handleMaxStopsChange = (val) => {
    setUseStops(true);
    setStops(val);
  };

  const handlePriceChange = (val) => {
    setUsePriceRange(true);
    setPriceRange(val);
  };

  const handleBaggageChange = (val, type) => {
    setUseBaggage(true);
    let counts = { ...baggage };
    if (type === "cabin") {
      counts.hand_bag = val;
    } else {
      counts.hold_bag = val;
    }
    setBaggage(counts);
  };

  function showDetails(flightDetail) {
    setShow(true);
    setFlightDetail(flightDetail);
  }

  const handleDepartureTimeChange = (val) => {
    setUseDepartureTimeRange(true);
    setDepartureTimeRange(val);
  };

  const handleArrivalTimeChange = (val) => {
    setUseArrivalTimeRange(true);
    setArrivalTimeRange(val);
  };

  const screenSize = window.innerWidth;

  useEffect(() => {
    if (screenSize > 720) {
      setShowFilters(true);
    } else {
      setShowFilters(false);
    }
  }, []);
  console.log("screenSize", screenSize);

  const searchBox = (
    <FlightSearch
      selectedDepartureDate={selectedDepartureDate}
      setSelectedDepartureDate={setSelectedDepartureDate}
      journeyType={journeyType}
      setJourneyType={setJourneyType}
      selectedArrivalDate={selectedArrivalDate}
      setSelectedArrivalDate={setSelectedArrivalDate}
      departureAirport={departureAirport}
      setDepartureAirport={setDepartureAirport}
      departureAirportName={departureAirportName}
      setDepartureAirportName={setDepartureAirportName}
      arrivalAirport={arrivalAirport}
      setArrivalAirport={setArrivalAirport}
      arrivalAirportName={arrivalAirportName}
      setArrivalAirportName={setArrivalAirportName}
      adults={adults}
      setAdults={setAdults}
      kids={kids}
      setKids={setKids}
      infants={infants}
      setInfants={setInfants}
      flightClass={flightClass}
      setFlightClass={setFlightClass}
      onSearchFlights={searchFlights}
    />
  );

  return (
    <>
      {screenSize && screenSize > 720 && (
        <div className={classes["search-box-container"]}>
          <div style={{ maxWidth: "70%", margin: "0 auto" }}>{searchBox}</div>
        </div>
      )}
      <div className={classes["mobile-filter"]}>
        <div className={classes["mobile-filter-inside"]}>
          <Typography
            variant="h5"
            component="h5"
            className={classes["filter-heading"]}
          >
            {departureAirportName}
          </Typography>
          <CompareArrows className={classes["compare-icon"]} />
          <Typography
            variant="h5"
            component="h5"
            className={classes["filter-heading"]}
          >
            {arrivalAirportName}
          </Typography>
        </div>

        <button
          disabled=""
          className={classes["apply-filters"]}
          onClick={() => {
            setShowFilters(!showFilters);
          }}
        >
          Apply Filters
        </button>
      </div>
      <div className={classes["second-page-container"]}>
        {/* Filters */}
        {/* {showFilters && ( */}
        <FlightFilter
          flyDuration={flyDuration}
          handleFlyDurationChange={handleFlyDurationChange}
          useflyDuration={useflyDuration}
          setUseFlyDuration={setUseFlyDuration}
          useSortBy={useSortBy}
          setUseSortBy={setUseSortBy}
          handleSortByChange={handleSortByChange}
          priceRange={priceRange}
          handlePriceChange={handlePriceChange}
          usePriceRange={usePriceRange}
          setUsePriceRange={setUsePriceRange}
          arrivalTimeRange={arrivalTimeRange}
          useArrivalTimeRange={useArrivalTimeRange}
          setUseArrivalTimeRange={setUseArrivalTimeRange}
          baggage={baggage}
          handleBaggageChange={handleBaggageChange}
          useBaggage={useBaggage}
          setUseBaggage={setUseBaggage}
          departureTimeRange={departureTimeRange}
          useDepartureTimeRange={useDepartureTimeRange}
          setUseDepartureTimeRange={setUseDepartureTimeRange}
          stops={stops}
          handleMaxStopsChange={handleMaxStopsChange}
          useStops={useStops}
          setUseStops={setUseStops}
          handleDepartureTimeChange={handleDepartureTimeChange}
          handleArrivalTimeChange={handleArrivalTimeChange}
          minMaxPrice={minMaxPrice}
          setShowFilters={setShowFilters}
          showFilters={showFilters}
        />
        {/* )} */}

        <FlightList flights={flights} showDetails={showDetails} />
        <FlightDetails
          flightDetails={flightDetail}
          show={show}
          closeDetails={setShow.bind(this, false)}
          history={props.history}
        />
      </div>
      <Footer />
      <Loader show={loading} />
    </>
  );
}

const mapStateWithProps = (state) => {
  let commissionType = "";
  let commissionValue = 0;
  if (state.vendor && state.vendor.vendorDetail) {
    commissionType = state.vendor.vendorDetail.commissionType;
    commissionValue = state.vendor.vendorDetail.commissionValue;
  }
  let adminCommissionType = "Fixed";
  let adminCommissionValue = 0;
  if (
    state.admin &&
    state.admin.commission &&
    state.admin.commission.commissionType
  ) {
    adminCommissionType = state.admin.commission.commissionType;
    adminCommissionValue = state.admin.commission.commissionValue;
  }
  return {
    searches: state.searchHistory.searches,
    currency: state.flight.currency ? state.flight.currency : "",
    commissionValue: commissionValue,
    commissionType: commissionType,
    adminCommissionValue: adminCommissionValue,
    adminCommissionType: adminCommissionType,
  };
};

export default React.memo(connect(mapStateWithProps)(FlightResults));
